import { DatePicker, Typography, Form } from 'antd';
import { Rule } from 'antd/es/form';
import { Dayjs } from 'dayjs';
import { SharedTimeProps } from 'rc-picker';
import { useTranslation } from 'react-i18next';

import Icon from 'utils/icon';

interface FormItemInputProps {
	label?: string;
	onChange?: (date: Dayjs | null) => void;
	style?: React.CSSProperties;
	minDate?: Dayjs;
	maxDate?: Dayjs;
	disabled?: boolean;
	value?: Dayjs;
	name?: string | string[];
	rules?: Rule[];
	showTime?: boolean | SharedTimeProps<Dayjs>;
	allowClear?: boolean;
	isLoading?: boolean;
}

function DatePickerElement({
	label,
	style,
	minDate,
	maxDate,
	disabled,
	value,
	name,
	rules,
	showTime,
	allowClear = false,
	isLoading = false,
	onChange,
}: FormItemInputProps) {
	const { t } = useTranslation();

	const pickerProps = {
		inputReadOnly: true,
		style,
		disabled,
		suffixIcon: <Icon style={{ animation: isLoading ? 'spin 1s linear infinite' : '' }} name={isLoading ? 'loading' : 'calendar'} />,
		placeholder: t('COMMON.SELECT_DATE'),
		allowClear,
		showNow: false,
		showTime,
		format: showTime ? 'DD-MM-YYYY hh:mm a' : 'DD-MM-YYYY',
		needConfirm: false,
		disabledDate: (current: Dayjs) => !!minDate && current < minDate,
		maxDate: maxDate,
	};

	return (
		<>
			{label && (
				<Typography.Text className="d-block" style={{ marginBottom: 5, display: 'block', fontSize: 15, textAlign: 'start' }}>
					{label}
				</Typography.Text>
			)}

			{name ? (
				<Form.Item name={name} rules={rules}>
					<DatePicker {...pickerProps} style={{ width: 'var(--inputWidth)', maxWidth: '100%', ...style }} onChange={onChange} />
				</Form.Item>
			) : (
				<DatePicker {...pickerProps} style={{ width: 'var(--inputWidth)', maxWidth: '100%', ...style }} value={value} onChange={onChange} />
			)}
		</>
	);
}

export default DatePickerElement;
